import { useEffect, useState } from "react";
import { getWindowHeight, getWindowWidth } from "../helpers/Helpers";

export const useWindowDimensions = () => {
    const getCurrentDimensions = () => (
        {
            width: getWindowWidth(),
            height: getWindowHeight()
        });

    const [dimensions, setDimensions] = useState<Dimensions>({
        width: getWindowWidth(),
        height: getWindowHeight()
    });

    const onResize = () => {
        setDimensions(getCurrentDimensions());
    };

    useEffect(() => {
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        }
    });

    return dimensions;
};

export type Dimensions = {
    width: number,
    height: number
}
